
import {useAuthStore} from "../../../../store/hooks";

export const useAdminLayout = () => {
  const {links} = useAuthStore();

  return {links}
}